import React from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { Divider } from "styled_components/Common/Divider";
import { LoadingSpinner } from "styled_components/Common/LoadingSpinner";
import format from "date-fns/format";

const ComponentStyle = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10px;
  background: ${(props) => props.theme.componentBackground};
  color: ${(props) => props.theme.defaultFontColor};
  .loading {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .transaction-wrapper {
    height: 150px;
    margin-bottom: 10px;
  }
  .ScrollbarsCustom-Track {
    right: -6px !important;
    top: 10px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.billing} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }
  .transaction-header {
    flex: 1;
    display: flex;
    .transaction-detail {
      &.date {
        min-width: 88px;
      }
      &.desc {
        flex: 1;
      }
      &.total {
        display: flex;
        min-width: 70px;
      }
    }
  }
  .transaction {
    display: flex;
    height: 30px;
    align-items: end;
    position: relative;

    .transaction-detail {
      &.desc {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }
      &.date {
        min-width: 88px;
      }
      &.total {
        display: flex;
        min-width: 70px;
      }
    }
  }
  .buttons {
    height: 20%;
    display: flex;
    justify-content: center;
    #okay {
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    padding: 10px;
    .loading {
      height: 150px;
    }
    .transaction-wrapper {
      height: 175px;
      margin-bottom: 10px;
    }
    .ScrollbarsCustom-Track {
      right: -6px !important;
      top: 10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.billing} !important;
      width: 8px !important;
    }
    .ScrollbarsCustom-TrackY:before {
      border-left: none;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
    }
    .transaction-header {
      .transaction-detail {
        &.date {
          min-width: 110px;
        }
        &.total {
          min-width: 80px;
        }
      }
    }
    .transaction {
      display: flex;
      height: 30px;
      .transaction-detail {
        &.desc {
          flex: 1;
          margin-right: 20px;
        }
        &.date {
          min-width: 110px;
        }
        &.total {
          display: flex;
          min-width: 80px;
        }
      }
    }
    .buttons {
      height: 20%;
      display: flex;
      justify-content: center;
      #okay {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    padding: 20px;
    .loading {
      height: 250px;
    }
    .transaction-wrapper {
      height: 300px;
      margin-bottom: 10px;
    }
    .ScrollbarsCustom-Track {
      right: -6px !important;
      top: 10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.billing} !important;
      width: 8px !important;
    }
    .ScrollbarsCustom-TrackY:before {
      border-left: none;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
    }
    .transaction-header {
      height: 30px;
      .transaction-detail {
        &.date {
          min-width: 150px;
        }

        &.total {
          min-width: 120px;
        }
      }
    }
    .transaction {
      display: flex;
      height: 30px;
      .transaction-detail {
        &.desc {
          flex: 1;
          margin-right: 30px;
        }
        &.date {
          min-width: 150px;
        }
        &.total {
          display: flex;
          min-width: 120px;
        }
      }
    }
    .buttons {
      height: 20%;
      display: flex;
      justify-content: center;
      #okay {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }
`;

export const BillingTransactions = ({
  downloadPdf,
  viewInvoice,
  invoice,
  transactions,
  loading,
}) => {
  const formatDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
      return "";
    }
    return format(new Date(dateString), "MMM d, yyyy");
  };

  return (
    <ComponentStyle>
      <div className="transaction-wrapper">
        <ScrollView>
          <div className="transaction-header">
            <div className="transaction-detail labels21 date">Date</div>
            <div className="transaction-detail labels21 desc">Description</div>
            <div className="transaction-detail labels21 total">Total</div>
          </div>
          {loading && (
            <div className="loading">
              <LoadingSpinner />
            </div>
          )}
          {transactions &&
            transactions.map((transaction, index) => (
              <div className="transaction" key={transaction?.recordNo}>
                <div className="transaction-detail body10 date">
                  {formatDate(new Date(transaction.created), "MM-DD-YYYY")}
                </div>
                <div className="transaction-detail body10 desc">
                  {transaction.itemDescription}
                </div>
                <div className="transaction-detail body10 total">
                  {`$${transaction.total}`}
                </div>
                {index !== 0 && <Divider />}
              </div>
            ))}
        </ScrollView>
      </div>

      <div className="buttons">
        <BloxButton
          className="buttons41"
          id="okay"
          text="View"
          module="billing"
          enabled={true}
          onClick={() =>
            viewInvoice(
              invoice?.invoiceId,
              invoice?.invoice_number,
              invoice?.docId
            )
          }
          cypressId="view"
        />{" "}
        <BloxButton
          className="buttons41"
          id="okay"
          text="Download"
          module="billing"
          enabled={true}
          onClick={() =>
            downloadPdf(invoice?.invoiceId, invoice?.type, invoice?.docId)
          }
          cypressId="download"
        />
      </div>
    </ComponentStyle>
  );
};
